var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbitalRotationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.8815C19 15.8061 15.8129 18.9877 11.8814 18.9877C10.3439 18.9877 8.92033 18.5011 7.75667 17.6739M5 12.1184C5 8.19384 8.18714 5.01232 12.1186 5.01232C13.6561 5.01232 15.0797 5.49885 16.2433 6.32606M5.16984 15.2314L6.42827 19L8.94506 16.4876L5.16984 15.2314ZM18.8302 8.76857L15.0549 7.51239L17.5718 5L18.8302 8.76857Z",
    stroke: "#88919A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbitalRotationIcon);
export default __webpack_public_path__ + "static/media/OrbitalRotationIcon.7a31e648799f0ea1b805398dbe2d58dc.svg";
export { ForwardRef as ReactComponent };